import React from 'react';
import ClientsReceiptsLayout from './clients-receipts-layout';

export default class ClientsReceipts extends React.Component<{}, {}> {
    render(){
        return(
            <ClientsReceiptsLayout/>
        )
    }
}